"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MEFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_146)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_146`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#E6BE53"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.5965 1.40356H28.5965V22.5965H-4.5965V1.40356Z",
					fill: "#E01D24"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.4386 7.92278C11.7474 8.23155 12.2526 8.23155 12.5614 7.92278L12.2316 8.2526L13.8246 6.65962C14.1684 6.34383 14.6737 6.26664 15.1018 6.46313L15.2491 6.5333C15.6491 6.73681 15.7193 7.14383 15.4105 7.4526L15.7404 7.12278L14.1404 8.72278C13.8246 9.06664 13.7474 9.5719 13.9439 9.99997L14.0141 10.1473C14.2176 10.5473 14.3719 11.228 14.3719 11.6631V10.8701C14.3719 11.3052 14.6807 11.5087 15.0877 11.3052L15.2351 11.2351C15.6351 11.0315 15.7053 10.6245 15.3965 10.3158L15.7263 10.6456C15.4176 10.3368 15.4176 9.83155 15.7263 9.52278L15.3965 9.8526C15.7614 9.46664 16.0702 9.03857 16.3158 8.57541L16.386 8.42804C16.5895 8.02804 16.8281 7.36839 16.9404 6.94032L17.3474 5.30523C17.4526 4.88418 17.7614 4.82804 18.0211 5.17892L19.4386 7.06664C19.7053 7.42453 19.9228 8.04909 19.9228 8.51225V10.0842C19.9228 10.5263 19.7684 11.193 19.5649 11.607L19.4948 11.7544C19.2491 12.2175 18.9404 12.6456 18.5755 13.0315L18.0983 13.5087C17.7193 13.8737 17.2912 14.1824 16.8211 14.428L16.6737 14.4982C16.2737 14.7017 15.586 14.8561 15.1579 14.8561C14.7228 14.8561 14.6737 15.0105 15.0807 15.214L15.2281 15.2842C15.6281 15.4877 16.1965 15.8947 16.5053 16.2035L16.1755 15.8737C16.4842 16.1824 16.9895 16.1824 17.2983 15.8737L16.9684 16.2035C17.2772 15.8947 17.7825 15.8947 18.0912 16.2035L17.7895 15.8596C18.1123 16.2035 18.1895 16.7087 17.993 17.1368L17.9228 17.2842C17.7193 17.6842 17.193 18 16.7719 18C16.2456 17.9789 15.7333 17.8596 15.2562 17.6421L15.1088 17.5719C14.6526 17.3193 14.2807 16.9473 14.0281 16.4912L13.9579 16.3438C13.7544 15.9438 13.3474 15.8737 13.0386 16.1824L13.3684 15.8526C13.0597 16.1824 13.0035 16.6807 13.2421 17.0666L13.9649 18.1473C14.2035 18.5052 14.1053 18.9965 13.7474 19.2351L12.6667 19.9579C12.2667 20.1965 11.7684 20.1965 11.3614 19.9579L10.2807 19.2351C9.92282 18.9965 9.82458 18.5123 10.0632 18.1473L10.786 17.0666C11.0246 16.6807 10.9684 16.1824 10.6597 15.8526L10.9895 16.1824C10.6807 15.8737 10.2737 15.9298 10.0702 16.3438L10 16.4912C9.79651 16.8912 9.33335 17.3614 8.91931 17.5719L8.77195 17.6421C8.37195 17.8456 7.68423 18 7.25616 18C6.77195 17.9789 6.33686 17.7052 6.10528 17.2842L6.0351 17.1368C5.83861 16.7087 5.92282 16.2035 6.23861 15.8596L5.90879 16.1894C6.21756 15.8807 6.72282 15.8807 7.03159 16.1894L6.70177 15.8596C7.01054 16.1684 7.51581 16.1684 7.82458 15.8596L7.49475 16.1894C7.88072 15.8245 8.30879 15.5158 8.77195 15.2701L8.91931 15.2C9.31931 14.9965 9.27019 14.8421 8.84212 14.8421C8.31581 14.821 7.80352 14.7017 7.32633 14.4842L7.17896 14.414C6.71581 14.1684 6.28774 13.8596 5.90177 13.4947L5.42458 13.0175C5.05967 12.6386 4.75089 12.2105 4.50528 11.7403L4.4351 11.593C4.21756 11.1158 4.09124 10.5965 4.07721 10.0701V8.4912C4.07721 8.04909 4.29475 7.39646 4.56142 7.04558L5.97896 5.15786C6.24563 4.79997 6.54738 4.85611 6.65265 5.28418L7.05967 6.91927C7.20002 7.43155 7.38247 7.92979 7.61405 8.40699L7.68423 8.55436C7.88774 8.95436 8.29475 9.52278 8.60353 9.83155L8.2737 9.50172C8.58247 9.8105 8.58247 10.3158 8.2737 10.6245L8.60353 10.2947C8.29475 10.6035 8.35089 11.0105 8.76493 11.214L8.9123 11.2842C9.3123 11.4877 9.62809 11.2842 9.62809 10.8491V11.6421C9.62809 11.207 9.78247 10.5403 9.98598 10.1263L10.0562 9.97892C10.2526 9.55085 10.1755 9.0526 9.85967 8.70172L8.26668 7.10874L8.59651 7.43857C8.28774 7.12979 8.34388 6.72278 8.75791 6.51927L8.90528 6.44909C9.33335 6.2526 9.8316 6.32979 10.1825 6.64558L11.7755 8.23857L11.4386 7.92278ZM10.1755 5.06664C9.86668 4.75786 9.95089 4.39997 10.3719 4.25962L11.2421 3.96488C11.6632 3.82453 12.3298 3.82453 12.7509 3.96488L13.6211 4.25962C14.0421 4.39997 14.1263 4.75786 13.8176 5.06664L13.3404 5.54383C12.9684 5.87365 12.4912 6.07015 11.993 6.09822C11.5579 6.09822 10.9544 5.8526 10.6456 5.54383C10.6526 5.54383 10.1755 5.06664 10.1755 5.06664Z",
					fill: "#E6BE53"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.4141 14.0491C10.4141 14.4842 10.5334 14.4982 10.7088 14.0842C10.7088 14.0842 11.207 12.4561 12 12.4561C12.793 12.4561 13.3053 14.1122 13.3053 14.1122C13.4597 14.5122 13.586 14.4842 13.586 14.035V13.2491C13.586 11.9368 12.8772 10.8701 12 10.8701C11.1228 10.8701 10.4141 11.9368 10.4141 13.2491V14.0491Z",
					fill: "#215F90"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_146`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MEFlag };
